import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/AdminImageUploader";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/upload-images/")({
  head: () => routeHead("/admin/upload-images/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
